import React, { useState, useEffect } from 'react';
import { BrandButton } from '@/components/brand/Buttons';
import { LogoMark } from '@/components/brand/Logo';
import { initAnalyticsIfConsented } from '@/lib/analytics';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      const t = setTimeout(() => setShowBanner(true), 1000);
      return () => clearTimeout(t);
    }
    // Returning visitor who already accepted — analytics may start.
    initAnalyticsIfConsented();
  }, []);

  const accept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    setShowBanner(false);
    initAnalyticsIfConsented();
  };

  const decline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-50 px-4 pb-4 sm:px-6 sm:pb-6 animate-fade-up"
      role="dialog"
      aria-label="Cookie preferences"
    >
      <div className="mx-auto max-w-4xl rounded-2xl bg-cream-50 border border-border/70 shadow-soft-3 p-5 sm:p-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-6">
          <LogoMark size={26} className="text-clay-700 shrink-0" />

          <div className="flex-1">
            <p className="font-display text-base text-ink leading-snug">
              A small note about cookies.
            </p>
            <p className="mt-1.5 text-[13.5px] text-ink-soft leading-relaxed">
              We use them for essentials (signing you in), affiliate tracking (so partner brands can
              credit us — at no cost to you), and to improve the site. See our{' '}
              <a
                href="/privacy"
                className="text-clay-700 hover:text-clay-800 underline decoration-clay-300 underline-offset-2"
              >
                privacy policy
              </a>{' '}
              for details.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto sm:shrink-0">
            <BrandButton variant="ghost" size="sm" onClick={decline}>
              Essential only
            </BrandButton>
            <BrandButton size="sm" onClick={accept}>
              Accept all
            </BrandButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
